import { render } from 'lithent';
import { Layout } from '@/components/Layout';
import '@/input.css';

// Render the application
render(<Layout />, document.body);
